import { checkAuth } from '@src/libs/localStorage'
import { TPostOption, TQueryOption } from '@src/modules/option'
import { useMutation, useQuery } from 'react-query'
import { notification } from 'antd'
import { TResApi, TResApiErr } from '@src/configs/interface.config'
import { LANGUAGE_DEFAULT, NError, NSuccess } from '@src/configs/const.config'
import { createOption, getOptionByKeys } from '@queries/apis'
import { DETAIL_OPTION } from '@queries/keys'

export const useMutationCreateOption = () => {
  const accessToken = checkAuth()
  return useMutation((data: any) => createOption(data, accessToken), {
    onSuccess: (res: TResApi<TPostOption>) => {
      notification.success({ message: NSuccess, description: res?.message })
    },
    onError: (error: TResApiErr) => {
      // [TODO] ...
      notification.error({ message: NError, description: error?.message })
    },
  })
}

export const useQueryOptionByKey = (params: TQueryOption, lang = LANGUAGE_DEFAULT) => {
  const accessToken = checkAuth()
  return useQuery<TResApi<TPostOption>>(
    [DETAIL_OPTION, JSON.stringify(params), lang],
    () => getOptionByKeys(params, accessToken, lang),
    {
      enabled: !!accessToken && params?.['key[]']?.length > 0,
    },
  )
}
